import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Skeleton } from 'antd';
import axios from 'axios';
import { FloatButton } from 'antd';
import config from '../../settings/config.json';

import wave from "../../assets/svg/wave.svg";
import logo from "../../assets/img/logo.png";

const Navbar = function() {
  const [isTop, setIsTop] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        setSettings(response.data[0]);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchSettings();
    
    const interval = setInterval(fetchSettings, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setIsTop(window.pageYOffset < 100);
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const scrollToAboutM = () => {
    const aboutSection = document.getElementById('about2');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const scrollToMessages = () => {
    const aboutSection = document.getElementById('message');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const scrollToMessagesM = () => {
    const aboutSection = document.getElementById('message2');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const scrollToHome = () => {
    const aboutSection = document.getElementById('home');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className='Navbar'>
      <nav className={`navbar navbar-expand-lg navbar-dark ${isTop ? 'navbar-top' : 'navbar-scroll'}`}>

        <Link 
          to='/' 
          className='navbar-brand ms-4 fw-bolder' 
          onClick={scrollToHome}
        >
          <img 
            src={logo} 
            width='40%' 
            alt="Logo" 
            onClick={closeMenu}
          />
        </Link>

        <button 
          className='navbar-toggler me-3' 
          type="button" 
          onClick={toggleMenu} 
          aria-controls="navbarNav" 
          aria-expanded={isOpen} 
          aria-label="Toggle navigation"
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className='navbar-nav'>
            <li className='nav-item me-2'>
              <Link className='nav-link regular qw-pc' to='/' onClick={scrollToAbout}>{settings?.client?.navbar?.aboutUs ? settings?.client?.navbar?.aboutUs: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link className='nav-link regular qw-mobile' to='/' onClick={scrollToAboutM}>{settings?.client?.navbar?.aboutUs ? settings?.client?.navbar?.aboutUs: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link to='/poets' className='nav-link regular' onClick={closeMenu}>{settings?.client?.navbar?.poets ? settings?.client?.navbar?.poets: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link className='nav-link regular qw-pc' to='/' onClick={scrollToMessages}>{settings?.client?.navbar?.contactUs ? settings?.client?.navbar?.contactUs: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link className='nav-link regular qw-mobile' to='/' onClick={scrollToMessagesM}>{settings?.client?.navbar?.contactUs ? settings?.client?.navbar?.contactUs: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link to='/video' className='nav-link regular' onClick={closeMenu}>{settings?.client?.navbar?.video ? settings?.client?.navbar?.video: <Skeleton.Button active />}</Link>
            </li>
            <li className='nav-item me-2'>
              <Link to='/poetry' className='nav-link regular' onClick={closeMenu}>{settings?.client?.navbar?.poetry ? settings?.client?.navbar?.poetry: <Skeleton.Button active />}</Link>
            </li>
          </ul>

          <ul className="navbar-nav social-admin ms-auto">
            <li className="nav-item fs-5 me-1">
              <a href={settings?.links?.youtube ? settings?.links?.whatsapp: '#'} target="_blank" rel="noopener noreferrer" className='nav-link'>
                <i className="fa-brands fa-whatsapp"></i>
              </a>
            </li>

            <li className="nav-item fs-5 me-1">
              <a href={settings?.links?.youtube ? settings?.links?.instagram: '#'} target="_blank" rel="noopener noreferrer" className='nav-link'>
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>

            <li className="nav-item fs-5 me-1">
              <a href={settings?.links?.youtube ? settings?.links?.youtube: '#'} target="_blank" rel="noopener noreferrer" className='nav-link'>
                <i className="fa-brands fa-youtube"></i>
              </a>
            </li>

            <li className="nav-item fs-5 me-3">
              <Link to='/login' className='nav-link'>
                <i className="fa-solid fa-user-tie text-danger"></i>
              </Link>
            </li>
          </ul>
        </div>

      </nav>
      <FloatButton.BackTop className='qw-mobile' visibilityHeight={0} />
      <div className="wave-container">
        <img src={wave} alt="Wave" className="wave-image" />
      </div>
    </div>
  )
}

export default Navbar;